import classNames from 'classnames';
import { FieldError } from 'react-hook-form';

type CustomWrapperFieldsProps = {
  label: string;
  comp?: React.ReactNode;
  error: FieldError | undefined;
  children?: React.ReactNode;
  newVerify?: boolean;
};

const CustomWrapperFields = (props: CustomWrapperFieldsProps) => {
  const { label, error, comp, children, newVerify } = props;
  return (
    <div
      className={classNames('input-box', {
        newStyle: newVerify,
        invalid: Boolean(error)
      })}
    >
      <label htmlFor="">
        {label}
        {comp ? comp : null}
      </label>
      {children}
    </div>
  );
};

export default CustomWrapperFields;
